module.exports = "<p>{{title}}</p>\n<p>{{message}}</p>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-success\" ng-click=\"ok()\" style=\"text-transform:capitalize;\" translate>OK</button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/common/modalBasicPopup.html
// module id = 73
// module chunks = 0